// extracted by mini-css-extract-plugin
export var actionButton = "_ih-0";
export var fileInput = "_ih-2";
export var paperclip = "_ih-1";